import React, { useEffect } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import NoContentPage from "../../../layout/dashboard/no-content/NoContentPage";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { getThirdPartyDetails } from "../../../redux/thirdParty";
import { systemRoles } from "../../../utils/roles";

interface myComponentProps {
  title?: string;
  children?: React.ReactNode;
  btnLabel?: string;
  onBtnClick?: () => void;
  hideBtn?: boolean;
  hideBtnIcon?: boolean;
  btnLoading?: boolean;
  pageLoading?: boolean;
  btnDisable?: boolean;
  titleText?: string;
  titleSelectComp?: any;
}

const ThirdPartyLayout = ({
  children,
  title,
  btnDisable,
  btnLabel,
  btnLoading,
  hideBtn,
  hideBtnIcon,
  onBtnClick,
  pageLoading,
  titleText,
  titleSelectComp,
}: myComponentProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const navList = [
    { name: "Payaza Account", link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_PAYAZA },
    { name: "Blaize Account", link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_BLAZE },
    { name: "Bridge Account", link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_BRIDGE },
    {
      name: "Zojapay Account",
      link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_ZOJAPAY,
    },
  ];
  const dispatch = useDispatch();
  const { third_party_info } = useSelector(
    (state: RootState) => state.thirdParty,
  );

  useEffect(() => {
    if (
      Object.keys(third_party_info)?.length < 1 &&
      user?.permissions?.includes(systemRoles[29])
    ) {
      dispatch(getThirdPartyDetails({}) as any);
    }
  }, []);

  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[29]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, []);

  return (
    <>
      <DashboardLayoutMain title={"Third-Party Application"}>
        <div className="third-party-layout-index-wrapper-general-box">
          {/* left wrap start */}
          <div className="left-side-wrap">
            <div className="nav-list-box">
              {navList?.map((chi, idx) => {
                return (
                  <div
                    key={idx}
                    className={`nav-item ${
                      location?.pathname === chi?.link ? `nav-item-active` : ``
                    }`}
                    onClick={() => {
                      if (chi?.link) {
                        navigate(chi?.link);
                      }
                    }}
                  >
                    <p className="name">{chi?.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {/* left wrap end */}
          {/* right wrap start */}
          <div className="right-side-wrap">
            {/* header btn wrap start */}
            <div className="header-btn-wrap">
              {/* title btn start */}
              <TitleBtnFragment
                selectFragment={titleSelectComp}
                text={titleText}
                hideBtn
                title={title}
              />
              {/* title btn end */}
              {/* <p className="title-settings">{title || ""}</p> */}
              {/* btn box start */}
              {/* {!hideBtn && (
                <div className="btn-setting-box-wrap">
                  <RazorButton
                    onClick={() => {
                      onBtnClick && onBtnClick();
                    }}
                    loading={btnLoading}
                    color="black-light"
                    className="btn"
                    disabled={btnDisable}
                  >
                    {!hideBtnIcon && (
                      <figure className="img-box">{ALL_ICONS?.plus}</figure>
                    )}
                    <p className="text">{btnLabel}</p>
                  </RazorButton>
                </div>
              )} */}
              {/* btn box end */}
            </div>
            {/* header btn wrap end */}
            {/* body start */}
            <div className="body-content-wrap">
              {" "}
              {pageLoading ? (
                <>
                  <NoContentPage loading={true} />
                </>
              ) : (
                <>{children}</>
              )}{" "}
            </div>
            {/* body end */}
          </div>
          {/* right wrap end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default ThirdPartyLayout;
